import { Route, Routes } from 'react-router-dom'

import { BlockedPermanently, BlockedTemporarily } from '~containers'

function Block() {
  return (
    <Routes>
      <Route path="temporario" element={<BlockedTemporarily />} />
      <Route path="permanente" element={<BlockedPermanently />} />
    </Routes>
  )
}

export default Block
